import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import ElementPlus from 'element-plus'
import 'element-plus/dist/index.css'

const app = createApp(App)
app.use(ElementPlus)
app.use(router).mount('#app')

app.config.errorHandler = (err, vm, info) => {
    console.log(err);
}

app.config.globalProperties.$baseUrl = "https://edupay.weihai.cn/api"

app.config.globalProperties.$objectToQueryString = (obj: any) => {
    let queryString = '?'
    for (let key in obj) {
        queryString += `${key}=${obj[key]}&`
    }
    return queryString.slice(0, -1);
}
